export const clearStorageRetainCookies = () => {
  const cookiePolicy = localStorage.getItem('cookiePolicy');
  const targetCookies = localStorage.getItem('targetCookies');
  const funcCookies = localStorage.getItem('funcCookies');
  const perfCookies = localStorage.getItem('perfCookies');
  
  localStorage.clear();
  
  if (cookiePolicy !== null) localStorage.setItem('cookiePolicy', cookiePolicy);
  if (targetCookies !== null) localStorage.setItem('targetCookies', targetCookies);
  if (funcCookies !== null) localStorage.setItem('funcCookies', funcCookies);
  if (perfCookies !== null) localStorage.setItem('perfCookies', perfCookies);
};
